import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { StreamArchiveItem } from 'services/endpoints/streaming'

export interface StreamArchivePagination {
  current_page: number
  per_page: number
  total: number
  last_page: number
}

interface StreamsArchiveCacheState {
  archives: StreamArchiveItem[]
  pagination: StreamArchivePagination | null
  setArchives: (
    archives: StreamArchiveItem[],
    pagination: StreamArchivePagination,
    append?: boolean
  ) => void
  clear: () => void
}

export const useStreamsArchiveCacheStore = create<StreamsArchiveCacheState>()(
  persist(
    (set) => ({
      archives: [],
      pagination: null,

      setArchives: (incoming, incomingPagination, append = false) =>
        set((state) => ({
          archives: append ? [...state.archives, ...incoming] : incoming,
          pagination: incomingPagination
        })),

      clear: () =>
        set({
          archives: [],
          pagination: null
        })
    }),
    {
      name: 'streams-archive-cache',
      partialize: (state) => ({
        archives: state.archives,
        pagination: state.pagination
      })
    }
  )
)